"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ReactLink = _interopRequireDefault(require("@micado-digital/react-link/ReactLink"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));

var _conditionalWrapper = _interopRequireDefault(require("../helper/conditionalWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DetectButton = function DetectButton(_ref) {
  var color = _ref.color,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "weiter" : _ref$label,
      link = _ref.link,
      linkTarget = _ref.linkTarget,
      icon = _ref.icon,
      iconSize = _ref.iconSize,
      size = _ref.size,
      variant = _ref.variant;
  var REACT_APP_SPA = process.env.REACT_APP_SPA;
  var buttonLabel = label;

  if (linkTarget === "_blank") {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: link,
      target: linkTarget,
      rel: "noreferrer"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: color,
      endIcon: icon && /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
        src: icon,
        size: iconSize
      }),
      size: size,
      variant: variant
    }, buttonLabel));
  } else {
    return /*#__PURE__*/_react.default.createElement(_conditionalWrapper.default, {
      condition: link,
      wrapper: function wrapper(children) {
        return REACT_APP_SPA ? /*#__PURE__*/_react.default.createElement(_ReactLink.default, {
          to: link
        }, children) : /*#__PURE__*/_react.default.createElement("a", {
          href: link,
          target: linkTarget
        }, children);
      }
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: color,
      endIcon: icon && /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
        src: icon,
        size: iconSize
      }),
      size: size,
      variant: variant
    }, buttonLabel));
  }
};

var _default = DetectButton;
exports.default = _default;